import React, { FC } from "react";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum } from "@/components/YhFormBox/Types";
import { RouterParamType } from "@/model/navModel";
import { useDtpDetailModel } from "../dtpDetailModel";
import useGlobalModel from '@/model/globalModel';

export const SystemFormBox: FC<RouterParamType> = ({ id, mode, formRef }) => {
    const {
        addFormVal,
        editFormVal,
        updateFormVal
    } = useDtpDetailModel(({ addFormVal, editFormVal }) => [addFormVal, editFormVal]);

    const { isEditable } = useGlobalModel(() => []);
    const formVal = mode === "edit" ? editFormVal : addFormVal;

     //表单change
     const onChange = (changedValues: { [key: string]: any }, values: any) => {
        updateFormVal(mode, values);
    }

    const FormItem: IYhFormItemsBox = {
        title: "系统信息",
        style: { padding: "10px 0 0 0", marginBottom: "75px" },
        contentClass: "pr-2",
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建人",
                fieldName: "createUser",
                disable: true
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "创建时间",
                fieldName: "createTime",
                disable: isEditable
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改人",
                fieldName: "updateUser",
                disable: true
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "修改时间",
                fieldName: "updateTime",
                disable: isEditable
            },
        ]
    };

    const stockEntryFromConfig: IYhFormBox = {
         formRef,
        labelCol: { span: 8 },
        labelAlign: "right",
        formValues: formVal,
        boxs: [FormItem],
        onChange
    }


    return (
        <YhFormBox {...stockEntryFromConfig} />
    )
}